// Module
var code = `<form-section form-title="'Please confirm the following:'" class="dashboard-collections__requirements-section">
  <table class="table table--generate-row-ids">
    <tbody>
    <tr>
      <td></td>
      <td>Search by:</td>
      <td>
        <select
          required
          ng-model="\$ctrl.searchBy"
          ng-change="\$ctrl.initializeFilters()"
          ng-options="searchBy | prettyEnum for searchBy in \$ctrl.searchByOptions">
        </select>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Date to:</td>
      <td>
        <date ng-required="true" ng-model="\$ctrl.selectedFilter().dateTo"></date>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Products:</td>
      <td ng-if="\$ctrl.searchBy === 'INDIVIDUAL'">
        <multiselect
          items="\$ctrl.loanTypes"
          ng-model="\$ctrl.individualFilter.loanTypeIds"
          select-all-option="true"
          label-property="'name'"
          value-property="'id'"
          ng-required="true">
        </multiselect>
      </td>
      <td ng-if="\$ctrl.searchBy === 'GROUP'">
        <multiselect
          items="\$ctrl.loanTypes"
          ng-model="\$ctrl.groupFilter.loanTypeIds"
          select-all-option="true"
          label-property="'name'"
          value-property="'id'"
          ng-required="true">
        </multiselect>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Branches:</td>
      <td ng-if="\$ctrl.searchBy === 'INDIVIDUAL'">
        <select
          ng-options="branch.id as branch.name for branch in \$ctrl.branches"
          ng-model="\$ctrl.individualFilter.branchId"
          ng-change="\$ctrl.updateFilterOptions()"
          required>
        </select>
      </td>
      <td ng-if="\$ctrl.searchBy === 'GROUP'">
        <select
          ng-options="branch.id as branch.name for branch in \$ctrl.branches"
          ng-model="\$ctrl.groupFilter.branchId"
          ng-change="\$ctrl.updateFilterOptions()"
          required>
        </select>
      </td>
    </tr>

    <tr ng-if="\$ctrl.searchBy === 'INDIVIDUAL'">
      <td></td>
      <td>
        Customer name:
        <help title="Partially matches name of the customer. Case insensitive." ></help>
      </td>
      <td>
        <input ng-model="\$ctrl.individualFilter.customerName" type="text"/>
      </td>
    </tr>

    <tr ng-if="\$ctrl.searchBy === 'INDIVIDUAL'">
      <td></td>
      <td>
        Product number:
        <help title="Partially matches product number" ></help>
      </td>
      <td>
        <input ng-model="\$ctrl.individualFilter.productNumber" type="text"/>
      </td>
    </tr>

    <tr ng-if="\$ctrl.searchBy === 'GROUP'">
      <td></td>
      <td>Centers:</td>
      <td>
        <selectize
          options="\$ctrl.filteredCenters"
          config="\$ctrl.centerConfig"
          ng-model="\$ctrl.groupFilter.centerIds"
          ng-change="\$ctrl.updateFilterOptions()">
        </selectize>
      </td>
    </tr>

    <tr ng-if="\$ctrl.searchBy === 'GROUP'">
      <td></td>
      <td>Group:</td>
      <td>
        <selectize
          options="\$ctrl.filteredGroups"
          config="\$ctrl.groupConfig"
          ng-model="\$ctrl.groupFilter.groupCustomerIds">
        </selectize>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Officer name:</td>
      <td>
        <user-select
          hide-role="true"
          ng-model="\$ctrl.selectedFilter().officerId"
          users="\$ctrl.officers">
        </user-select>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Collector name:</td>
      <td>
        <user-select
          hide-role="true"
          ng-model="\$ctrl.selectedFilter().collectorId"
          users="\$ctrl.collectors">
        </user-select>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Sort by:</td>
      <td>
        <select
          ng-model="\$ctrl.selectedFilter().sortBy"
          ng-options="s.value as s.label for s in \$ctrl.sortByOptions"
          ng-required="true">
        </select>
      </td>
    </tr>
    </tbody>
  </table>
</form-section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/collections/filter/collections-filter.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;